
const BaseURL = "http://localhost:8080/Uploads/"

export default BaseURL;
